import { useEffect } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { translate, type Lang, type TranslationKey } from '@/i18n/translations';

interface I18nState {
  lang: Lang;
  setLang: (l: Lang) => void;
}

export const useI18n = create<I18nState>()(
  persist(
    (set) => ({
      lang: 'th',
      setLang: (lang) => set({ lang }),
    }),
    { name: 'baiboon_v8_lang' }
  )
);

/** Translation hook — returns a `t(key)` function bound to current lang. */
export function useT() {
  const lang = useI18n((s) => s.lang);
  return (key: TranslationKey | string) => translate(key, lang);
}

/** Sync <html lang="..."> attribute when language changes. */
export function I18nSync() {
  const lang = useI18n((s) => s.lang);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return null;
}
